module.exports = __webpack_public_path__ + "img/no-screenshots-captured.b89ba59c.png";